import React from 'react'
import styled from 'styled-components'

const SVGWrapper = styled.div`
  max-height: 100%;
  max-width: 100%;
  margin-bottom: 140px;
`

const DisconnectedView = () => <SVGWrapper />

export default DisconnectedView
